export function SalesSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/sales.svg'"></ng-include>`
    }
}